import { ProgressBar } from '@ets/design-system';
import styles from './Loading.module.scss';

type props = {
  label: string;
  testId: string;
};

const Loading = ({ label, testId }: props) => {
  return (
    <div className={styles.loading_container}>
      <ProgressBar size="m" variant="primary-dark" testId={testId}>
        {label}
      </ProgressBar>
    </div>
  );
};

export default Loading;
